<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-form ref="query" :model="query" inline>
        <el-form-item prop="isNoCheck" label="包括未审核单据">
          <el-checkbox v-model="query.isNoCheck" size="small" />
        </el-form-item>
        <el-form-item prop="fStockID" label="仓库">
          <el-select
            v-model="query.fStockID"
            style="width: 200px"
            size="small"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in stockList"
              :key="item.fStockID"
              :value="item.fStockID"
              :label="item.fName"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="fICItemID" label="产品">
          <el-select-table
            v-model="query.fICItemID"
            :label.sync="fName"
            url="ICItemManage/ICItem/ChoiceICItemEntry"
            label-field="fName"
            value-field="ficItemID"
            size="small"
            :extra-param="{prohibit:false}"
            panel-width="500px"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },
              { prop: 'fModel', label: '规格' },
              { prop: 'fUnit', label: '单位' },
            ]"
          />
        </el-form-item>
        <el-form-item prop="startDate" label="入库日期">
          <el-date-picker
            v-model="query.startDate"
            type="date"
            placeholder="选择日期"
            size="small"
            style="width: 150px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item prop="endDate" label="至">
          <el-date-picker
            v-model="query.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 150px"
            size="small"
          />
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="small"
        style="margin-right: 10px"
        @click="refresh"
      >查询</el-button>
      <el-button-export
        v-if="candown"
        :url="downloadUrl"
        type="primary"
        size="small"
      >下载报表</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fNumber" label="产品编码" />
        <el-table-column prop="fName" label="产品名称" />
        <el-table-column prop="fModel" label="规格" />
        <el-table-column prop="fBatchNo" label="批号" />
        <el-table-column prop="fUnit" label="单位" />
        <el-table-column prop="fQty" label="数量" />
        <el-table-column prop="fDate_Sc" label="生产日期" />
        <el-table-column
          prop="fDate"
          label="入库日期"
        />
        <el-table-column prop="fBillNo" label="入库单号" />
        <el-table-column prop="fStock" label="所属仓库" />
        <el-table-column prop="fState" label="单据状态" />
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data() {
    return {
      query: {
        isNoCheck: null,
        fStockID: null,
        fICItemID: null,
        startDate: null,
        endDate: null
      },
      fName: '',
      stockList: [],
      ICItemList: [],
      tableData: [],
      loading: false,
      currentEditItem: null,
      candown: true
    }
  },
  mounted() {
    // this.refresh()
    this.getStockEntry()
    const newtime = moment(new Date()).format('YYYY-MM-DD')
    this.query.startDate = newtime
    this.query.endDate = newtime
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '006001002') {
        this.candown = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('Report/InStockReport', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    getStockEntry() {
      this.$httpPost('Warehouse/Stock/StockEntry', {}).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.stockList = res.datalist
      })
    },

    _view: function(row) {
      const url = this.$route.path + '/' + row.fid
      this.$router.push(url)
    },
    _delete: function(row) {
      this.$httpPost(`OrderManage/OrderTemporary/DeleteOrderTemporary`, {
        fid: row.fid
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    downloadUrl: function() {
      const req = this.query
      return this.$buildDownloadUrl(
        'LogisticsSystemApi/Report/InStockReportDownload',
        { ...req }
      )
    },
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style scoped lang='less'>
.query-bar {
}
</style>
